import { Routes, Route } from 'react-router-dom'

import Favorites from 'pages/Favorites'
import MultipleDevices from 'pages/MultipleDevices'

const FavoritesRouter = () => {
  return (
    <Routes>
      <Route path='multiple/:id/'>
        <Route path=":activeTab" element={<MultipleDevices pathRoot="favorites" />} />
        <Route path="" element={<MultipleDevices pathRoot="favorites" />} />
      </Route>
      <Route path=":id" element={<Favorites />} />
      <Route index element={<Favorites />} />
    </Routes>
  )
}

export default FavoritesRouter
